module.exports = __webpack_public_path__ + "img/1080_20.d2dd58d7.jpg";